export default "PQV Open Statement : {{STORE_NAME}}\n"